export default {"src":"/_next/static/media/arrawIcon-1.082f1fbb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};